const flame = {
  blue: "Blue",
  focused: "Focused",
  highDispersion: "High Dispersion",
  orange: "Orange",
  red: "Red",
  semiFocused: "Semi Focused",
  yellow: "Yellow"
};

export default flame;
